import { usePagination } from "@/hooks";
import { GetMonthlyInvoiceParams } from "@/redux/apis/payment/types";

export const useGetMonthlyInvoiceParams = () => {
  const { page, pageSize } = usePagination();

  const params: GetMonthlyInvoiceParams = {
    page,
    page_size: pageSize,
  };

  return { params, page, pageSize };
};
